import React from 'react';
import PropTypes from 'prop-types';
import { filterPairs, getUrlSeparator } from '../utils';
import css from './UrlPreview.css';

const UrlPreview = ({ baseUrl, pairs }) => {
    const filled = filterPairs(pairs);
    return (
        <code className={css.urlPreview}>
            {baseUrl}
            {filled.length > 0 && getUrlSeparator(baseUrl)}
            {filled.map((p, i) => (
                // Pair includes index because callers may render rows with duplicate keys
                // (the duplicate-key error state) and React would otherwise warn.
                // eslint-disable-next-line react/no-array-index-key
                <span key={`${i}-${p.key}`}>
                    {i > 0 && '&'}
                    {p.key}=<span className={css.value}>{p.value}</span>
                </span>
            ))}
        </code>
    );
};

UrlPreview.propTypes = {
    baseUrl: PropTypes.string.isRequired,
    pairs: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string,
            value: PropTypes.string,
        })
    ).isRequired,
};

export default UrlPreview;
